"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _DepositReferenceIdModal = _interopRequireDefault(require("./DepositReferenceIdModal"));
var _modalDecorator = _interopRequireDefault(require("../../../../hocs/modalDecorator"));
var _modalActions = require("../../../../redux/actions/modalActions");
var _config = _interopRequireDefault(require("../../../../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var _state$deposit$deposi = state.deposit.depositStatus,
    requestcode = _state$deposit$deposi.requestcode,
    referenceid = _state$deposit$deposi.referenceid;
  var referenceCode = _config["default"].Deposit.useShortDepositId ? referenceid : requestcode;
  return {
    referenceCode: referenceCode
  };
};
var container = (0, _reactRedux.connect)(mapStateToProps, null)(_DepositReferenceIdModal["default"]);
var _default = exports["default"] = (0, _modalDecorator["default"])({
  name: _modalActions.MODAL_TYPES.DEPOSIT_REFERENCE_ID
})(container);